export const policyPattern = /^[WwQqFf][a-zA-Z0-9,d]{7}$/
export const namepattern = /^[a-zA-Z .,+-@/()'&]*$/
export const nricpattern = /^[STFGMstfgm]\d{7}[A-Za-z]$/
export const mobilepattern = /^[89][0-9,\d]{7}$/
export const phonepattern = /^[3689][0-9,\d]{7}$/
export const permitpattern = /^([045][\s][0-9-]{8})$/
export const amountpattern = /^[1-9]\d*(,[0-9]{1,3}){0,2}?(\.[0-9]{1,2})?$/
export const refundAmountpattern = /^[0-9]\d*(,[0-9]{1,3}){0,9}?(\.[0-9]{1,2})?$/
export const datepattern = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/[0-9]{4}$/
export const timepattern = /^([01]?[0-9]|2[0-3]):([0-5][0-9]){1}?$/
